import {
    CHANGE_PASSWORD_ERROR,
    CHANGE_PASSWORD_ERROR_CLEAR,
    CHANGE_PASSWORD_PENDING,
    CHANGE_PASSWORD_SUCCESS,
    CLOSE_CHANGE_PASSWORD_MODAL,
    OPEN_CHANGE_PASSWORD_MODAL,
} from "./constants"

const initialState = {
    isChangePasswordPending: false,
    changePasswordErrorMessage: null,
    isSuccess: false,
    isChangePasswordModal: false,
}

const changePassword = (state = initialState, action) => {

    switch (action.type) {
        case CHANGE_PASSWORD_PENDING: {
            return {
                ...state,
                isChangePasswordPending: true
            }
        }

        case CHANGE_PASSWORD_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...state,
                changePasswordErrorMessage: errorMessage,
                isChangePasswordPending: false,
                isSuccess: false,
            }
        }

        case CHANGE_PASSWORD_ERROR_CLEAR: {
            return {
                ...state,
                changePasswordErrorMessage: null,
                isChangePasswordPending: false,
                isSuccess: false,
            }
        }

        case CHANGE_PASSWORD_SUCCESS: {
            return {
                ...state,
                isSuccess: true,
                changePasswordErrorMessage: null,
                isChangePasswordPending: false,
            }
        }

        case OPEN_CHANGE_PASSWORD_MODAL: {
            return {
                ...state,
                isChangePasswordModal: true,
            }
        }
        case CLOSE_CHANGE_PASSWORD_MODAL: {
            return {
                ...state,
                isChangePasswordModal: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default changePassword;